
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useGeolocation() {
  const [geoLocation, setGeoLocation] = useState<{
    countryCode?: string;
    countryName?: string; // Add countryName to the type
    regionCode?: string;
    city?: string;
    source?: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const fetchGeoLocation = async () => {
      setIsLoading(true);
      try {
        console.log('Fetching geolocation data...');
        
        // Option to pass a specific IP for testing, normally null
        const response = await supabase.functions.invoke('geolocation', {
          body: { ip: null } // Let the function detect the IP from the request
        });
        
        if (response.error) {
          throw new Error(response.error.message);
        }
        
        if (response.data) {
          // Store geolocation data with additional metadata
          setGeoLocation({
            countryCode: response.data.countryCode,
            countryName: response.data.countryName, // Include countryName in the state
            regionCode: response.data.regionCode,
            city: response.data.city,
            source: response.data.source
          });
          
          console.log('Geolocation data:', response.data);
        } else {
          throw new Error('No geolocation data returned');
        }
      } catch (err) {
        console.error('Error fetching geolocation:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchGeoLocation();
  }, []);

  return { geoLocation, isLoading, error };
}
